import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom-v5-compat';
import { PurchaseOrdersGridContextProvider } from './purchase-orders-grid-context';
import { UserHasRoleAndSubscription } from '../../../role-based-route';
import { PagingContextProvider } from '../../../contexts/paging-context';
import { useUserSetting } from '../../../hooks/use-user-setting';
import { UserSettings } from '../../../enums/user-settings/user-settings';
import { PAGE_SIZE_250 } from '../../../services/pagination-service';

/**
 * Layout component for purchase orders routes with Context Providers
 * Provides PagingContextProvider and PurchaseOrdersGridContext to all nested routes (list and detail pages)
 * @returns {JSX.Element} Layout with context providers and outlet for nested routes
 */
export const PurchaseOrdersLayout = () => {
  const userSetting = useUserSetting(UserSettings.purchaseOrdersGridPageSize.settingName);
  const userPageSize = useMemo(() => parseInt(userSetting || PAGE_SIZE_250, 10), [userSetting]);

  return (
    <UserHasRoleAndSubscription>
      <PagingContextProvider page={1} pageSize={userPageSize}>
        <PurchaseOrdersGridContextProvider>
          <Outlet />
        </PurchaseOrdersGridContextProvider>
      </PagingContextProvider>
    </UserHasRoleAndSubscription>
  );
};
